export default "__VITE_ASSET__hnDhNTd3__"